import dynamicfunction from '../../utils/dynamicfunction';
import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { getFundDetail } from '../../store/actions/fund-action';
import { setFundDetail } from '../../store/slices/fund-slice';
import { getClientHoldings } from '../../store/actions/fund-investment-action';

export default () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();

  const fund_id = state?.systemFundId ?? state?.data?.fundId;

  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { investmentContent } = useSelector((state) => state.content);
  const { fund_detail, fund_loading } = useSelector((state) => state.fund);

  const [showModal, setShowModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    dispatch(setFundDetail(null));
    await dispatch(getFundDetail(`${fund_id}&myFund=${true}`));
  };

  const getContentKey = (key) => {
    return getContentKeyAccToLang(investmentContent?.my_fund_report?.data?.attributes, key, isArabic);
  };

  const handleDownloadFile = async (fileUrl) => {
    if (!fileUrl) return;

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileUrl.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };
  return {
    fund_detail,
    TextWeight,
    getContentKey,
    navigate,
    direction,
    isArabic,
    fund_loading,
    showModal,
    setShowModal,
    selectedDocument,
    setSelectedDocument,
    handleDownloadFile,
  };
};
